module.exports = __webpack_public_path__ + "img/balkonglasdach_1.ba259640.webp";